<div class="qb-w-100 qb-h-100 qb-main-create-new">
  <div class="qb-heading-main-container">
    <div>
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>
  <div class="qb-challenge-listing-container main-white-panel">
    <app-challenge-type-selection
      *ngIf="progressType === 'typeselection'"
      class="qb-creation-div-wrapper"
      (challengeTypeData)="challengeTypeData($event)"
    ></app-challenge-type-selection>
    <app-get-challenge-details-page
      *ngIf="progressType === 'challengedetails'"
      class="qb-creation-div-wrapper"
      [isEdit] = "isEdit"
      [status] = "status"
      [duplicateNameErrorText] = "duplicateNameErrorText"
      (challengeDetails)="challengeDetails($event)"
    ></app-get-challenge-details-page>
  </div>
</div>
